import { ChangeDetectorRef, Component, Injectable, OnInit, TemplateRef } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import { environment } from 'environments/environment';
import { CommonService } from '../../../../../../common/services/Common.service';
import { UploadService } from '../../../../../../common/services/Upload.service';
import { ChatService } from '../../../../../../common/services/Chat.service';
import { BaseComponent } from '../../../../../../components/base.component';
import { BsModalService } from 'ngx-bootstrap';

declare var $: any;

@Component({
  selector: 'settings-conversation-live-chat',
  templateUrl: './live-chat.component.html',
  styleUrls: ['./live-chat.component.css'],
  providers: [CommonService],
})
@Injectable()
export class LiveChatComponent extends BaseComponent {
  public model: any = {};
  public embed: any = '';
  public tab: any = 'tab-config';

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private commonService: CommonService,
    private uploadService: UploadService,
    private chatService: ChatService
  ) {
    super(changeDetector, toastr, modalService);
  }

  ngOnInit() {
    const _tenant_id = this.user.tenant_id ? this.user.tenant_id : this.user.id;
    this.embed = `<script type="text/javascript">window.addEventListener("message", function (event) {var viewportWidth = window.innerWidth || document.documentElement.clientWidth; if (event.data.action === 'resizeIframe' && viewportWidth <= 768) {document.getElementById('3c_chat_iframe').style.width = event.data.width;document.getElementById('3c_chat_iframe').style.height = event.data.height;}else{document.getElementById('3c_chat_iframe').style.width = "100%";document.getElementById('3c_chat_iframe').style.height = "520px";}if(event.data.message == "closeChatBox"){document.getElementById('3c-live-chat').style.width = "fit-content";document.getElementById('3c-live-chat').style.height = "fit-content";document.getElementById('3c_chat_iframe').style.width = "fit-content";document.getElementById('3c_chat_iframe').style.height = "fit-content";}if( event.data.message == "openChatBox"  && viewportWidth <= 768){document.getElementById('3c_chat_iframe').style.width = "100vw";document.getElementById('3c_chat_iframe').style.height = "100vh";}}); function loadJsAsync(t, e) { var n = document.createElement("script"); n.type = "text/javascript", n.src = t, n.addEventListener("load", function (t) { e(null, t) }, !1); var a = document.getElementsByTagName("head")[0]; a.appendChild(n) } window.addEventListener("DOMContentLoaded", function () { loadJsAsync("${environment.url_embed}/js/3cChat.js?v=2.1", function () { var t = { domain: "", tenant_id: '${_tenant_id}' }; embedCsChat(t) }) }, !1);</script>`;
    this.loadData();
  }

  async loadData(request: any = {}) {
    this.chatService.config().subscribe(res => {
      if (!res.error && res.status == 200) {
        this.model = res.data ? res.data : {};
        if (this.model && this.model.logo && this.model.logo != '') {
          this.model.url_logo = this.commonService.file(this.model.logo);
        }
      }
    });
  }

  changeFile($event) {
    const files = $event.srcElement.files;
    this.uploadService.upload(files[0]).then((res: any) => {
      if (!res.error && res.status == 200) {
        this.model.logo = res.data;
        this.model.url_logo = this.commonService.file(this.model.logo);
        $event.target.value = null;
      } else {
        this.throwError();
      }
    });
  }

  changeTab(tab) {
    this.tab = tab;
    this.loadData();
  }

  async updateConfig() {
    const payload = {};
    console.log(this.model);
    Object.keys(this.model).forEach(key => {
      if (this.model[key] !== null && this.model[key] !== undefined) {
        payload[key] = typeof this.model[key] == 'string' ? this.model[key].trim() : this.model[key];
      }
    });
    console.log(payload);
    delete this.model.url_logo;
    this.chatService.updateConfig(payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Cập nhật thành công!');
          this.loadData();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/conversation/live-chat/live-chat.component.ts